import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import { useSearchParams } from "react-router-dom";
import { useTaskListContext } from "../context/taskListContext";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiSelect-root": {
			backgroundColor: "#FFF",
		},
	},
	formControl: {
		width: "100%",
		margin: 0,
		"& .MuiFormLabel-root": {
			fontSize: 12.3,
			transform: "translate(14px, -6px) scale(0.75)",
			backgroundColor: "#FFF",
			padding: "0 3px",
		},
		"& .MuiInputLabel-shrink": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
	},
}));

type Props = {};

export const TypesFilter = ({}: Props) => {
	const classes = useStyles();
	const { state } = useTaskListContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get("type") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("type", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<div className={classes.root} style={{ marginTop: 8 }}>
			<FormControl variant="outlined" className={classes.formControl}>
				<InputLabel id="types-select-label">Types</InputLabel>
				<Select
					labelId="types-select-label"
					id="types-select"
					margin="dense"
					value={type}
					onChange={handleFilter}
					label="Types"
				>
					{state.typeCodes.map((type) => {
						return (
							<MenuItem key={`logId-${type.id}`} value={type.id}>
								<Grid container alignItems="center">
									{type.description}
								</Grid>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
};
